import React from 'react';

function Build() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      fill="none"
      viewBox="0 0 14 16"
    >
      <path
        fill="#3AB2EE"
        d="M13.625 15H13V.75a.75.75 0 00-.75-.75H1.75A.75.75 0 001 .75V15H.375a.375.375 0 00-.375.375V16h14v-.625a.375.375 0 00-.375-.375zM4 2.375C4 2.168 4.168 2 4.375 2h1.25c.207 0 .375.168.375.375v1.25A.375.375 0 015.625 4h-1.25A.375.375 0 014 3.625v-1.25zm0 3C4 5.168 4.168 5 4.375 5h1.25c.207 0 .375.168.375.375v1.25A.375.375 0 015.625 7h-1.25A.375.375 0 014 6.625v-1.25zM5.625 10h-1.25A.375.375 0 014 9.625v-1.25C4 8.168 4.168 8 4.375 8h1.25c.207 0 .375.168.375.375v1.25a.375.375 0 01-.375.375zM8 15H6v-2.625c0-.207.168-.375.375-.375h1.25c.207 0 .375.168.375.375V15zm2-5.375a.375.375 0 01-.375.375h-1.25A.375.375 0 018 9.625v-1.25C8 8.168 8.168 8 8.375 8h1.25c.207 0 .375.168.375.375v1.25zm0-3A.375.375 0 019.625 7h-1.25A.375.375 0 018 6.625v-1.25C8 5.168 8.168 5 8.375 5h1.25c.207 0 .375.168.375.375v1.25zm0-3A.375.375 0 019.625 4h-1.25A.375.375 0 018 3.625v-1.25C8 2.168 8.168 2 8.375 2h1.25c.207 0 .375.168.375.375v1.25z"
      ></path>
    </svg>
  );
}

export default Build;
